import React, { useEffect, useState } from "react";
import Layout from "../../layout";
import "react-datepicker/dist/react-datepicker.css";
import { Row } from "react-bootstrap";
import services from "../../API/services";
import { useSelector } from "react-redux";
import { authenticationSeletor } from "../../store/slices/authenticationSlice";
import Moment from "react-moment";
// import { Rating } from "@smastrom/react-rating";
import { Rating, Star } from "@smastrom/react-rating";
import ReactGA from "react-ga4";

const CustomerReviews = () => {
  const { userDetail } = useSelector(authenticationSeletor);
  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: "customer_ratings" });
    window.scrollTo(0, 0);
    getReview(userDetail?.propertyId);
  }, [userDetail]);

  const [tableData, setTableData] = useState([]);

  const getReview = async (id) => {
    try {
      const res = await services.globalService.getCustomerReviewPropertyIdService(id);
      if (res.status === 200) { setTableData(res.data.data); }
    } catch (error) { console.log("Error in getReview function") }
  };

  const getInitials = (name = "") => {
    return name
      .trim()
      .split(" ")
      .filter(Boolean)
      .slice(0, 2)
      .map(word => word.charAt(0).toUpperCase())
      .join("");
  };


  return (
    // <Layout title="Customer Reviews List" openHandler={false}>
    //   <Row className="mx-3 reviewAdminSection mt-2">
    //     {tableData.map((data, key) => {
    //       let arr = new Array(data.rating);
    //       arr.fill(1);
    //       return (
    //         data?.userId && (
    //           <div className="reviewCard" key={key}>
    //             <div className="comment">
    //               <div className="comment_header flex justify-content-between mb-2">
    //                 <div className="comment_header m-0">
    //                   <div className="comment_header-pic"></div>
    //                   <h2>{data?.User?.name ?? "N/A"}</h2>
    //                 </div>
    //                 <div>
    //                   <Rating style={{ maxWidth: 140 }}value={data.rating}readOnly/>
    //                   <div className="comment_footer flex flex-column align-items-end">
    //                     {data.createdAt && (<span><Moment format="DD/MM/YYYY">{data.createdAt}</Moment></span>)}
    //                   </div>
    //                 </div>
    //               </div>
    //               <div className="comment_content mt-0 ml-5 text-justify">
    //                 <p>{data.review}</p>
    //               </div>
    //             </div>
    //           </div>
    //         )
    //       );
    //     })}
    //   </Row>
    // </Layout>

    <Layout title="" openHandler={false}>
      <Row style={{ margin: "16px" }}>
        {tableData.map((data, key) => {
          const name = data?.User?.name ?? "N/A";
          const firstLetter = name.charAt(0).toUpperCase();          
          const initials = getInitials(name);
          return (
            data?.userId && (
              <div key={key} style={{ width: "100%", background: "#fff", padding: "16px", borderRadius: "10px", boxShadow: "0 2px 10px rgba(0,0,0,0.08)", marginBottom: "16px" }}>
                <div style={{ display: "flex", gap: "12px" }}>
                  <div style={{ width: "36px", height: "36px", borderRadius: "50%", background: "#2563eb", color: "#fff", display: "flex", alignItems: "center", justifyContent: "center", fontWeight: "bold", fontSize: "16px", flexShrink: 0 }}>
                    {initials}
                  </div>
                  <div style={{ flex: 1 }}>
                    <div style={{ fontSize: "15px", fontWeight: 600, marginBottom: "4px" }}>{name}</div>
                    <div style={{ alignItems: "center", gap: "8px", marginBottom: "0px" }}>
                      <Rating style={{ width: '100%', display: 'flex', fontSize: "10px" }} items={data.rating} readOnly />                      
                      {data.createdAt && (
                        <span style={{ width: '50px', fontSize: "12px", color: "#777", whiteSpace: "nowrap" }}>
                          <Moment format="DD/MM/YYYY">{data.createdAt}</Moment>
                        </span>
                      )}
                    </div>
                    <div style={{ fontSize: "15px", color: "#333", lineHeight: "1.6" }}>{data.review}</div>
                  </div>
                </div>
              </div>
            )
          );
        })}
      </Row>
    </Layout>
  );
};

export default CustomerReviews;
